import { render, staticRenderFns } from "./CompLiveCam.vue?vue&type=template&id=a031ad10"
import script from "./CompLiveCam.vue?vue&type=script&lang=js"
export * from "./CompLiveCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports